/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppConfiguration
 */
export interface AppConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    admin_email: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    application_admin_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    app_name: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    format_pattern_date: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    format_pattern_date_with_time: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    table_export_import_format: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_header_logo: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_header_title_1?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_header_title_2?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_header_background_color?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_header_environment?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_header_environment_closable?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_footer_logo: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_footer_url: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_login_lower_right_icon_image?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_login_lower_right_icon_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_login_middle_html_text?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_login_lower_html_text?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    default_first_page_url: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    default_search_title?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    default_search_uri?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_footer_title?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_footer_backend?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_footer_release?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_compact_browse_table?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_table_header_default?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    client_bx2_table_header_resized?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    login_flow?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    oidc_authentication_provider_label?: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    oidc_redirect_url?: string;
}

/**
 * Check if a given object implements the AppConfiguration interface.
 */
export function instanceOfAppConfiguration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "admin_email" in value;
    isInstance = isInstance && "app_name" in value;
    isInstance = isInstance && "format_pattern_date" in value;
    isInstance = isInstance && "format_pattern_date_with_time" in value;
    isInstance = isInstance && "table_export_import_format" in value;
    isInstance = isInstance && "client_bx2_header_logo" in value;
    isInstance = isInstance && "client_bx2_footer_logo" in value;
    isInstance = isInstance && "client_bx2_footer_url" in value;
    isInstance = isInstance && "default_first_page_url" in value;

    return isInstance;
}

export function AppConfigurationFromJSON(json: any): AppConfiguration {
    return AppConfigurationFromJSONTyped(json, false);
}

export function AppConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'admin_email': json['admin_email'],
        'application_admin_url': !exists(json, 'application_admin_url') ? undefined : json['application_admin_url'],
        'app_name': json['app_name'],
        'format_pattern_date': json['format_pattern_date'],
        'format_pattern_date_with_time': json['format_pattern_date_with_time'],
        'table_export_import_format': json['table_export_import_format'],
        'client_bx2_header_logo': json['client_bx2_header_logo'],
        'client_bx2_header_title_1': !exists(json, 'client_bx2_header_title_1') ? undefined : json['client_bx2_header_title_1'],
        'client_bx2_header_title_2': !exists(json, 'client_bx2_header_title_2') ? undefined : json['client_bx2_header_title_2'],
        'client_bx2_header_background_color': !exists(json, 'client_bx2_header_background_color') ? undefined : json['client_bx2_header_background_color'],
        'client_bx2_header_environment': !exists(json, 'client_bx2_header_environment') ? undefined : json['client_bx2_header_environment'],
        'client_bx2_header_environment_closable': !exists(json, 'client_bx2_header_environment_closable') ? undefined : json['client_bx2_header_environment_closable'],
        'client_bx2_footer_logo': json['client_bx2_footer_logo'],
        'client_bx2_footer_url': json['client_bx2_footer_url'],
        'client_bx2_login_lower_right_icon_image': !exists(json, 'client_bx2_login_lower_right_icon_image') ? undefined : json['client_bx2_login_lower_right_icon_image'],
        'client_bx2_login_lower_right_icon_url': !exists(json, 'client_bx2_login_lower_right_icon_url') ? undefined : json['client_bx2_login_lower_right_icon_url'],
        'client_bx2_login_middle_html_text': !exists(json, 'client_bx2_login_middle_html_text') ? undefined : json['client_bx2_login_middle_html_text'],
        'client_bx2_login_lower_html_text': !exists(json, 'client_bx2_login_lower_html_text') ? undefined : json['client_bx2_login_lower_html_text'],
        'default_first_page_url': json['default_first_page_url'],
        'default_search_title': !exists(json, 'default_search_title') ? undefined : json['default_search_title'],
        'default_search_uri': !exists(json, 'default_search_uri') ? undefined : json['default_search_uri'],
        'client_bx2_footer_title': !exists(json, 'client_bx2_footer_title') ? undefined : json['client_bx2_footer_title'],
        'client_bx2_footer_backend': !exists(json, 'client_bx2_footer_backend') ? undefined : json['client_bx2_footer_backend'],
        'client_bx2_footer_release': !exists(json, 'client_bx2_footer_release') ? undefined : json['client_bx2_footer_release'],
        'client_bx2_compact_browse_table': !exists(json, 'client_bx2_compact_browse_table') ? undefined : json['client_bx2_compact_browse_table'],
        'client_bx2_table_header_default': !exists(json, 'client_bx2_table_header_default') ? undefined : json['client_bx2_table_header_default'],
        'client_bx2_table_header_resized': !exists(json, 'client_bx2_table_header_resized') ? undefined : json['client_bx2_table_header_resized'],
        'login_flow': !exists(json, 'login_flow') ? undefined : json['login_flow'],
        'oidc_authentication_provider_label': !exists(json, 'oidc_authentication_provider_label') ? undefined : json['oidc_authentication_provider_label'],
        'oidc_redirect_url': !exists(json, 'oidc_redirect_url') ? undefined : json['oidc_redirect_url'],
    };
}

export function AppConfigurationToJSON(value?: AppConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'admin_email': value.admin_email,
        'application_admin_url': value.application_admin_url,
        'app_name': value.app_name,
        'format_pattern_date': value.format_pattern_date,
        'format_pattern_date_with_time': value.format_pattern_date_with_time,
        'table_export_import_format': value.table_export_import_format,
        'client_bx2_header_logo': value.client_bx2_header_logo,
        'client_bx2_header_title_1': value.client_bx2_header_title_1,
        'client_bx2_header_title_2': value.client_bx2_header_title_2,
        'client_bx2_header_background_color': value.client_bx2_header_background_color,
        'client_bx2_header_environment': value.client_bx2_header_environment,
        'client_bx2_header_environment_closable': value.client_bx2_header_environment_closable,
        'client_bx2_footer_logo': value.client_bx2_footer_logo,
        'client_bx2_footer_url': value.client_bx2_footer_url,
        'client_bx2_login_lower_right_icon_image': value.client_bx2_login_lower_right_icon_image,
        'client_bx2_login_lower_right_icon_url': value.client_bx2_login_lower_right_icon_url,
        'client_bx2_login_middle_html_text': value.client_bx2_login_middle_html_text,
        'client_bx2_login_lower_html_text': value.client_bx2_login_lower_html_text,
        'default_first_page_url': value.default_first_page_url,
        'default_search_title': value.default_search_title,
        'default_search_uri': value.default_search_uri,
        'client_bx2_footer_title': value.client_bx2_footer_title,
        'client_bx2_footer_backend': value.client_bx2_footer_backend,
        'client_bx2_footer_release': value.client_bx2_footer_release,
        'client_bx2_compact_browse_table': value.client_bx2_compact_browse_table,
        'client_bx2_table_header_default': value.client_bx2_table_header_default,
        'client_bx2_table_header_resized': value.client_bx2_table_header_resized,
        'login_flow': value.login_flow,
        'oidc_authentication_provider_label': value.oidc_authentication_provider_label,
        'oidc_redirect_url': value.oidc_redirect_url,
    };
}

